{
    "dashboard": {
        "title": "Dashboard"
    },
    "expense": {
        "title": "Expenses"
    },
    "subscriptions": {
        "title": "Subscriptions"
    },
    "credit_card": {
        "title": "Cards"
    },
    "employees": {
        "title": "Employees"
    },
    "cost_centers": {
        "title": "Cost center 1"
    },
    "vendors": {
        "title": "Vendors"
    },
    "reporting": {
        "title": "Reporting"
    },
    "settings": {
        "title": "Settings"
    },

    "transactions": {
        "title": "Transactions"
    },
    "error": {
        "not_found": {
            "title": "Sorry, this page could not be found.",
            "message": "The page you were looking for could not be found or does not exist."
        },
        "feature_deactivated": {
            "title": "You can’t access this page because the feature has been deactivated for your company.",
            "message": "If you need access, please contact your administrator."
        },
        "unknown": {
            "title": "Oops!",
            "message": "An unknown error occurred. Please try again later."
        },
        "button": {
            "return": "Return to dashboard"
        }
    },
    "kyb": {
        "title": "KYB"
    },
    "liquidity": {
        "title": "Liquidity Management"
    }
}
